import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import Filters from 'components/filters';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useExtrastockOffers from '../useExtrastockOffers';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const MainPage = () => {
  const navigate = useNavigate();
  const {
    data,
    columns,
    filters,
    onChangeTableFilter,
    loading,
    updateInProcess,
    onDelete,
    handleDownloadExcel,
  } = useExtrastockOffers();
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);

  const handleOnRow = useCallback(
    (record) => ({
      onClick: () => {
        navigate(`${record.id}`);
      },
    }),
    [navigate],
  );

  return (
    <>
      <PageHeader title={t('RICHIESTE EXTRASTOCK').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              loading={loading}
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          loading={loading}
          columns={columns}
          dataSource={data.extrastock_offers}
          pagination={data.pagination}
          scroll={{ x: 2000 }}
          onChange={onChangeTableFilter}
          onRow={handleOnRow}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
